import React, { useState } from "react";
import { ReactComponent as Cancel } from "../../../Assets/Image/svg/cancel.svg";
import { useForm, Controller } from "react-hook-form";
import { BtnPrimary } from "../../share/buttons/Btn";
import Inputs from "../../share/input/Inputs";
import SupportTicketQuill from "../../layouts/SupportTicket/SupportTicketQuill";
import useFetch from "../../../Hooks/useFetch";
import MessageQuill from "../Message/MessageQuill";

function NewIdeaModal({ close, getUserIdeas }) {
    const [ideaName, setIdeaName] = useState("");
    const [ideaDescription, setIdeaDescription] = useState("");

    const [call, setCall] = useState();

    const {
        register,
        handleSubmit,
        control,
        formState: { errors },
    } = useForm();

    const editIdeaPriority = useFetch({
        method: "POST",
        url: `UserBootCampIdeaService`,
        noHeader: false,
        caller: getUserIdeas,
        trigger: false,
        data: call,
    });

    const submitForm = () => {
        //TODO : pak kardane modal bad az patch

        const formData = new FormData();

        formData.append("bootcamp", 11);
        //TODO : id bootcamp dynamic she
        formData.append("idea_name", ideaName);
        formData.append("idea_description", ideaDescription);

        setCall(formData);
        editIdeaPriority.reFetch();

        close();
    };

    return (
        <div
            style={{ width: "30vw" }}
            className="AddnewsupportTicket relative "
        >
            <button
                onClick={() => close(false)}
                className="AddnewsupportTicket-cancel absolute  "
            >
                <div>
                    <Cancel />
                </div>
            </button>
            <p className=" text-[#77498F] text-[2rem] leading-[3.2rem] font-bold text-center mb-[5rem]">
                ثبت ایده
            </p>
            <form onSubmit={handleSubmit(submitForm)}>
                <input
                    register={{
                        required: {
                            value: true,
                            message: "Enter Name",
                        },
                    }}
                    type="text"
                    name="name"
                    control={control}
                    placeholder="نام ایده"
                    className="border-gray h-[6.4rem] w-full bg-white-dark placeholder-gray text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] mb-8 input"
                    onChange={(e) => setIdeaName(e.target.value)}
                />
                <MessageQuill
                    placeholder="توضیحات کلی*"
                    value={ideaDescription}
                    setValue={setIdeaDescription}
                />
                <BtnPrimary
                    className="py-[20px] px-[25px] flex mr-auto "
                    text="ثبت ایده"
                />
            </form>
        </div>
    );
}

export default NewIdeaModal;
